export const groupsModeEnum = {
  MANUAL: "manual",
  AUTO: "auto",
};

export const lampsSorterEnum = {
  ALL: "all",
  WHTG: "withoutGroups",
};
